import axios from 'axios';
import loadjs from 'loadjs';
import { isFunction, isNumber, isObject, isUndefined } from 'lodash-es';
import { getDapiRootUrl } from '../globalConfiguration';

const RECAPTCHA_SITE_KEY = '6LcXE7wsAAAAAMWAqREx40XZRn1e_vhS79iUZu5D';
const RECAPTCHA_SCRIPT_SRC = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
const RECAPTCHA_BUNDLE = 'grecaptcha';

function injectRecaptchaStyles() {
  if (document.getElementById('grecaptcha-badge-style')) {
    return;
  }

  const style = document.createElement('style');
  style.id = 'grecaptcha-badge-style';
  style.textContent = '.grecaptcha-badge { visibility: hidden; }';
  document.head.appendChild(style);
}

export async function loadGoogleRecaptcha() {
  if (!loadjs.isDefined(RECAPTCHA_BUNDLE)) {
    injectRecaptchaStyles();
    loadjs(RECAPTCHA_SCRIPT_SRC, RECAPTCHA_BUNDLE);
  }

  return new Promise((resolve) => {
    loadjs.ready(RECAPTCHA_BUNDLE, {
      success: () => {
        if (!isObject(window.grecaptcha?.enterprise)) {
          return resolve(null);
        }

        if (!isFunction(window.grecaptcha.enterprise.ready)) {
          return resolve(null);
        }

        window.grecaptcha.enterprise.ready(() => resolve(window.grecaptcha));
      },
      error: (error) => {
        console.log(error);
      },
    });
  });
}

export async function generateRecaptchaToken(action) {
  return new Promise((resolve) => {
    if (!loadjs.isDefined(RECAPTCHA_BUNDLE)) {
      return resolve(null);
    }

    const timeout = setTimeout(() => resolve(null), 1500);

    try {
      if (!isObject(grecaptcha)) {
        return resolve(null);
      }

      if (!isObject(grecaptcha?.enterprise)) {
        return resolve(null);
      }

      if (!isFunction(grecaptcha?.enterprise?.ready)) {
        return resolve(null);
      }

      if (!isFunction(grecaptcha?.enterprise?.execute)) {
        return resolve(null);
      }

      grecaptcha.enterprise.ready(async () => {
        const token = await grecaptcha.enterprise.execute(
          '6LcXE7wsAAAAAMWAqREx40XZRn1e_vhS79iUZu5D',
          {
            action,
          }
        );

        clearTimeout(timeout);

        return resolve(token);
      });
    } catch (error) {
      console.log(error);

      clearTimeout(timeout);

      return resolve(null);
    }
  });
}

export async function getRecaptchaScore(token, action) {
  try {
    const { data } = await axios.post(`${getDapiRootUrl()}/api/v1/recaptcha/verify`, {
      token,
      action,
    });

    if (!data) {
      return null;
    }

    const { score } = data;

    if (!isNumber(score)) {
      return null;
    }

    return score;
  } catch (error) {
    return null;
  }
}
